import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { Spinner } from "components"
import classes from "./CheckoutPlaceOrderContent.module.scss"

const CartPlaceOrderButtonContent = props => {
  const {
    sending,
    internalDeliveryDisabled,
    deliveryServiceOutOfRange,
    snapboxQuotaionLoading
  } = props

  const [t] = useTranslation()

  const temporaryOff =
    useSelector(state =>
      state.systemSettings.temporaryOff
    )

  if (temporaryOff)
    return (
      <div className={classes["text"]}>
        {t("فروشگاه_بسته_است")}
      </div>
    )

  const deliveryOutOfRange =
    internalDeliveryDisabled ||
    deliveryServiceOutOfRange

  if (deliveryOutOfRange)
    return (
      <span className={classes["text"]}>
        {t("سفارش_خارج_از_محدوده_است")}
      </span>
    )

  const showSpinner =
    sending ||
    snapboxQuotaionLoading

  if (showSpinner) {
    return <Spinner color="white" size={18} />
  }

  return (
    <span className={classes["text"]}>
      {t("ایجاد")}
    </span>
  )
}

export default React.memo(CartPlaceOrderButtonContent)